const DATE_FORMAT = { weekday: 'short', month: 'short', day: 'numeric' };

export { DATE_FORMAT };
